import DIApi from './_diApi';

class BudgetProvideAPI extends DIApi {
  controllerName = 'BudgetProvides';
}

export default new BudgetProvideAPI();
